export default "__VITE_ASSET__eW$J9gBB__"